import React from 'react';

import { Path, Svg } from './styles';
import { IconProps } from './types';

const path = [
  'M7.05 10H3.5V9H7.05C7.575 9 8.03117 8.83333 8.4185 8.5C8.80617 8.16667',
  '9 7.75 9 7.25C9 6.75 8.80617 6.33333 8.4185 6C8.03117 5.66667 7.575 5.5',
  '7.05 5.5H3.9L5.2 6.8L4.5 7.5L2 5L4.5 2.5L5.2 3.2L3.9 4.5H7.05C7.85833 4.5',
  '8.55217 4.7625 9.1315 5.2875C9.7105 5.8125 10 6.46667 10 7.25C10 8.03333',
  '9.7105 8.6875 9.1315 9.2125C8.55217 9.7375 7.85833 10 7.05 10Z',
].join(' ');

export const IconRefund = ({ width = 12, height = 13, className }: IconProps) => (
  <Svg className={className} width={width} height={height} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path fillRule="evenodd" clipRule="evenodd" d={path} />
  </Svg>
);

export default IconRefund;
